import AlumniTable from './AlumniTable';

export default AlumniTable;
